// extracted by mini-css-extract-plugin
export var orderDetails = "_rx-2";
export var orderImage = "_rx-1";
export var orderMeta = "_rx-3";
export var orderSummary = "_rx-0";
export var rightArrow = "_rx-4";